import React, {useContext, useEffect, useState} from 'react'
import Modal from "../../../Modal";
import AdministracionUsuarioService from "../../../../services/AdministracionUsuarioService";
import CarritoService from "../../../../services/CarritoService";
import AppContext from "../../../../store/AppContext";
import RegistroDominioService from "../../../../services/RegistroDominioService";

export const ModalItemRenovacionDominio = ({ nombreDominio, handleOnClose, isOpen, setMensajeOk, setError }) => {

    const appCtx = useContext(AppContext);

    const [aniosRenovacion, setAniosRenovacion] = useState([1]);
    const [cantAnios, setCantAnios] = useState(1);

    const extensionDesdeNombre = (nombre) => {
        const m = (nombre || '').match(/[.].*/);
        return m ? m[0] : '';
    };

    useEffect(() => {
        setError({error : false, mensaje: "Sin errores"});
        const ext = extensionDesdeNombre(nombreDominio);
        if (!ext) {
            return;
        }
        RegistroDominioService.obtenerTarifas(ext, 'RENOVACION').then((tarifa) => {
            const anios = (tarifa && tarifa.aniosContratacion && tarifa.aniosContratacion.length > 0)
                ? tarifa.aniosContratacion
                : [1];
            setAniosRenovacion(anios);
            setCantAnios(anios.includes(1) ? 1 : anios[0]);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nombreDominio, isOpen])

    const agregarItemCarrito = (e) => {
        e.preventDefault();
        setError({error : false, mensaje: "Sin errores"});

        let renovarDominioDTO = {
            nombreDominio : nombreDominio,
            cantAnios: Number(cantAnios),
            pagoVentaDTO: {
                generaPago: false,
                generaFactura: false
            }
        };
        AdministracionUsuarioService.renovarDominio(renovarDominioDTO)
            .then(response => {
                console.log(response);
                if (!response.esRespOK) {
                    setError({
                        error: true,
                        mensaje: response.mensaje
                    })
                } else {

                    let uuidVenta = response.uuidVenta;
                    appCtx.setVenta( { uuidVenta : uuidVenta});
                    refreshCarrito(uuidVenta);

                    setMensajeOk({
                        mostrarMensaje: true,
                        mensaje : "Se agrego la renovación al carrito de compras."
                    })
                    handleOnClose();
                }
            })
            .catch(() => {
                setError({
                    error: true,
                    mensaje: "Ha ocurrido un error al renovar dominio."
                })
            })
    }

    const refreshCarrito = (uuidVenta) => {
        CarritoService.refrescarVentaCarrito(uuidVenta).then(response => {
            if (response && response.stale) {
                return;
            }
            if (response.respuestaOK) {
                appCtx.refrescarCarrito(response.registrosPendientes, response.renovacionesPendientes, response.transferenciasTitularesPendientes);
            }
        })
    }

    const elegirAnios = (event) => {
        const anios = event.target.value;
        setCantAnios(anios);
    }

    return <>
        <Modal
            idDivModal="idModalRenovarCarrito"
            handleClose={handleOnClose} isOpen={isOpen} closeOnClickOutside={false}>

            <fieldset>

                <legend>Datos de renovaci&oacute;n</legend>

                <form id="form-item">

                    <div className="form-item">
                        <label htmlFor="id-anios">Años renovaci&oacute;n</label>
                        <select id="id-anios" value={cantAnios} onChange={elegirAnios}>
                            {aniosRenovacion.map((anio, index) => (
                                <option value={anio} key={index}>{anio} {anio > 1 ? 'años' : 'año'}</option>
                            ))}
                        </select>
                    </div>

                    <div className="right">
                        <button className="btn" onClick={agregarItemCarrito}>Agregar al carrito de compras</button>
                    </div>

                </form>

            </fieldset>

        </Modal>
    </>
}
